// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1kW_p","tab":"Tabs_tab__XwKt-","tabActive":"Tabs_tabActive__OUWXi"};